import { Gallery } from './gallery';

export type PROPERTY_STATUS = 'for sale' | 'for rent' | 'sold';
export enum PROPERTY_STATUS_ENUM {
  forSale = 'for sale',
  forRent = 'for rent',
  sold = 'sold',
}

export type PROPERTY_TYPE = 'house' | 'condominium' | 'apartment' | 'flat' | 'cottage';
export enum PROPERTY_TYPE_ENUM {
  house = 'house',
  condominium = 'condominium',
  apartment = 'apartment',
  flat = 'flat',
  cottage = 'cottage',
}

export interface Property {
  id: string;
  status: PROPERTY_STATUS;
  street: string;
  district?: string;
  city: string;
  zip: string;
  country: string;
  description: string;
  price: number;
  type: PROPERTY_TYPE;
  area: number;
  beds: number;
  baths: number;
  garages: number;
  features: string;
  image: string;
  video: string;
  currency: string;
  gallery: Gallery[];
  featured: boolean;
  agentName: string;
  agentEmail: string;
  createdAt: Date;
  updatedAt: Date;
}